import { render, staticRenderFns } from "./ImageUploadSection.vue?vue&type=template&id=553c8af8&scoped=true&"
import script from "./ImageUploadSection.vue?vue&type=script&setup=true&lang=js&"
export * from "./ImageUploadSection.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ImageUploadSection.vue?vue&type=style&index=0&id=553c8af8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553c8af8",
  null
  
)

export default component.exports